/* eslint-disable no-unused-vars */
import { Form, Cascader } from 'antd';
import React, { useContext } from 'react';
import { CascaderStyled } from './CascaderStyled';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';

const CascaderML = (props) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);

  let {
    name,
    options,
    placeVal = '请选择',
    labelVal,
    loadChildren,
    inputWidth,
    height,
    maxWidth,
    required,
    labelwidth,
    onChange,
    displayRender,
  } = props;

  const loadData = (selectedOptions) => {
    loadChildren(selectedOptions);
  };
  return (
    <React.Fragment>
      <CascaderStyled
        theme={themeContext}
        brand={brandContext}
        inputWidth={inputWidth}
        height={height}
        labelwidth={labelwidth}
      >
        <Form.Item
          colon={false}
          name={name}
          rules={required}
          className="cascader-box"
          label={<>{labelVal}</>}
        >
          <Cascader
            style={{ minWidth: inputWidth, height: height, maxWidth: maxWidth }}
            options={options}
            placeholder={placeVal}
            loadData={loadData}
            onChange={onChange}
            displayRender={displayRender}
            changeOnSelect={false}
          />
        </Form.Item>
      </CascaderStyled>
    </React.Fragment>
  );
};

export default CascaderML;
